var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container,
    attrs: {
      "id": "modal-resource-container",
      "data-modal-resource": ""
    }
  }, [_vm.loading || _vm.error ? _c('LoaderIcon', {
    staticClass: "m-auto",
    attrs: {
      "error": _vm.error
    }
  }) : _vm._e(), _c('Transition', {
    attrs: {
      "name": "motto-resource-slide"
    }
  }, [!_vm.loading && !_vm.error ? _c('div', {
    class: _vm.$style.modalResourceContainer
  }, [_c('MottoIcon', {
    class: _vm.$style.closeButton,
    attrs: {
      "name": "X",
      "icon-color": "gray",
      "data-close-modal-resource-button": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.closeModal.apply(null, arguments);
      }
    }
  }), _c('div', {
    class: _vm.$style.contentContainer
  }, [_c('div', {
    class: _vm.$style.contentHeader
  }, [_c('div', {
    class: _vm.$style.breadcrumbs
  }, [_c('p', {
    staticClass: "p2 color-darkest-gray cursor-pointer",
    on: {
      "click": _vm.clickBreadcrumb
    }
  }, [_vm._v("RESOURCES")]), _vm.resource.categoryName ? _c('BaseIcon', {
    staticClass: "color-gray",
    attrs: {
      "name": "chevron-right"
    }
  }) : _vm._e(), _vm.resource.categoryName ? _c('p', {
    staticClass: "p2 color-darkest-gray cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.clickBreadcrumb('category');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.resource.categoryName.toUpperCase()) + " ")]) : _vm._e(), _vm.resource.subcategoryName ? _c('BaseIcon', {
    staticClass: "color-gray",
    attrs: {
      "name": "chevron-right"
    }
  }) : _vm._e(), _vm.resource.subcategoryName ? _c('p', {
    staticClass: "p2 color-darkest-gray cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.clickBreadcrumb('subcategory');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.resource.subcategoryName.toUpperCase()) + " ")]) : _vm._e()], 1)]), _c('div', {
    staticClass: "position-relative"
  }, [_c('BaseLink', {
    class: _vm.$style.resourceTitleLink,
    attrs: {
      "to": {
        name: 'resource',
        params: {
          resourceId: _vm.resourceId
        }
      }
    }
  }, [_c('h2', {
    staticClass: "color-primary-blue",
    class: _vm.$style.resourceTitle
  }, [_vm._v(_vm._s(_vm.resource.title))])]), _vm.loadingFavorite ? _c('LoaderIcon', {
    staticClass: "d-inline",
    class: _vm.$style.heartIcon
  }) : _c('FavoriteHeart', {
    class: _vm.$style.heartIcon,
    attrs: {
      "is-favorite": _vm.isFavorite,
      "options": {
        width: 30,
        height: 30
      }
    },
    on: {
      "handleHeartClick": _vm.handleHeartClick
    }
  }), _vm.resource.resourceId ? _c('CopyToClipboardButton', {
    class: _vm.$style.clipboardButton,
    attrs: {
      "text-to-copy": _vm.resourceUrl
    }
  }) : _vm._e()], 1), _c('p', {
    staticClass: "p1 color-dark-gray"
  }, [_vm._v(_vm._s(_vm.resource.revisedAt))]), _c('p', {
    staticClass: "p1 color-primary-charcoal",
    class: _vm.$style.resourceTextContent,
    domProps: {
      "innerHTML": _vm._s(_vm.resource.content)
    }
  }), _vm.resource.tags.length ? _c('div', {
    staticClass: "tagsContainer",
    class: _vm.$style.resourceTags
  }, _vm._l(_vm.resource.tags, function (tag) {
    return _c('span', {
      key: tag,
      staticClass: "tag-text"
    }, [_vm._v(_vm._s(tag))]);
  }), 0) : _vm._e(), _vm.youtubeVideoId ? _c('youtube', {
    class: _vm.$style.frameVideo,
    attrs: {
      "video-id": _vm.youtubeVideoId,
      "player-width": "411",
      "player-height": "231"
    }
  }) : _vm._e(), _vm.vimeoVideoId ? _c('vimeo-player', {
    class: _vm.$style.frameVideo,
    attrs: {
      "video-id": _vm.vimeoVideoId,
      "player-width": "411",
      "player-height": "231"
    }
  }) : _vm._e(), _vm.resource.isDownloadable ? _c('ResourceDownloadFile', {
    attrs: {
      "resource": _vm.resource,
      "modal-button": true
    }
  }) : _vm._e()], 1)], 1) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }